import {
  AssessmentTestContext,
  AssessmentTestContextType,
} from '../../../contexts/assessment-test';
import React from 'react';
import {
  NonCopyableMarkdown,
  Option,
  OptionsContainer,
  SectionWrapper,
  NonCopyableMarkdownOption,
} from '../common';
import FollowUp from './FollowUp';

export default function MultipleChoiceSection({
  section,
  stepId,
}: {
  section: Extract<
    AssessmentTestContextType['steps'][number]['sections'][number],
    { type: 'multiple-choice' }
  >;
  stepId: string;
}) {
  const { answer, options, isSingleChoice, content } = section;
  const [, dispatch] = React.useContext(AssessmentTestContext);
  const setAnswer = React.useCallback(
    (value: Array<{ id: string; content: string }>) => {
      dispatch({
        type: 'CHANGE_ANSWER_MULTIPLE_CHOICE',
        payload: {
          stepId,
          sectionId: section.id,
          answer: value,
        },
      });
    },
    [stepId, section.id, dispatch]
  );
  const onSelectOption = (option: { id: string; content: string }) => {
    if (isSingleChoice) {
      setAnswer([option]);
    } else {
      setAnswer(
        answer.includes(option)
          ? answer.filter((o) => o.id !== option.id)
          : [...answer, option]
      );
    }
  };

  return (
    <SectionWrapper>
      <NonCopyableMarkdown md={content} />
      <OptionsContainer>
        {options.map((option) => (
          <Option
            key={option.id}
            onClick={() => {
              onSelectOption(option);
            }}
            isSelected={!!answer.find((o) => o.id === option.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelectOption(option);
              }
            }}
          >
            {/* <NonCopyableSpan>{option.content}</NonCopyableSpan> */}
            <NonCopyableMarkdownOption md={option.content} />
          </Option>
        ))}
      </OptionsContainer>
      <FollowUp section={section} stepId={stepId} />
    </SectionWrapper>
  );
}
